'use client';

import styled from 'styled-components';

import { Colors } from 'styles/enums';

export const TitleWrapper = styled.div`
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 3px solid;
  border-color: ${Colors.Yellow.base100};
`;

export const ArticleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 10px;
  row-gap: 20px;
`;
